import styled from '@emotion/styled'
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import formatNumber from '../../component/script/format_number';

const RankCombatStatWrapper = styled.section`
    margin-top: 50px;
    h3 {
        text-align: center;
    }
    ul {
        margin-top: 25px;
        display: flex;
        gap: 25px;
        flex-wrap: wrap;
        li {
            width: 100%;
            @media screen and (min-width: 345px) {
                width: calc((100% - 25px)/2);
            }
            @media screen and (min-width: 510px) {
                width: calc((100% - 50px)/3);
            }
            @media screen and (min-width: 675px) {
                width: calc((100% - 75px)/4);
            } 
            a {
                position: relative;
                display: flex;
                flex-flow: column;
                align-items: center;
                text-align: center;
                border-radius: 25px;
                padding: 25px;
                box-shadow: -5px -5px 10px 0px rgba(255, 255, 255, 0.75), 5px 5px 10px 0px rgba(0, 0, 0, 0.05);
                &:hover{
                    box-shadow: -5px -5px 10px 0px rgba(255, 255, 255, 0.75) inset, 5px 5px 10px 0px rgba(0, 0, 0, 0.05) inset;
                }
                .rank {
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    top: -20px;
                    background-color: rgba(65, 84, 255, 1);
                    min-width: 40px;
                    min-height: 40px;
                    border-radius: 99999px;
                    font-size: 12px;
                    color: var(--color-white-900);
                    font-weight: 700;
                    &.background-black {
                        background-color: var(--color-black-200);
                    }
                }
                .combat-stat {
                    font-weight: 700;
                }
                img {
                    display: block;
                    max-width: 100%;
                }
            }
        }
    }
`

const RankCombatStat = ()=>{
    const [arrCombatStat, setArrCombatStat] = useState(null);

    useEffect(
        ()=>{
            const getArrCombatStat = async () => {
                try {
                    // 주어진 URL에 GET 요청 보내기
                    const response = await axios.get(`https://maple-frieza.com/data/rank/combat-power`);
                    setArrCombatStat(response.data.arrCharactorCombatStatTopRank);
                } catch (error) {
                    console.log(error)
                }
            }

            getArrCombatStat()
            
        }, []
    )
    return(
        <RankCombatStatWrapper>
            <article>
                <h3 className="hidden">전투력 순위</h3>
                <ul>
                    {
                        arrCombatStat?
                        arrCombatStat.map(
                            (element, index)=>{
                                let indexString = index.toString();
                                let numberLabel = "th";
                                let background = null;
                                
                                if (indexString.length > 1 && indexString.slice(-2, 1) === "1") {
                                    numberLabel = "th";
                                } else {
                                    if (indexString.slice(-1) === "0") {
                                        numberLabel = "st";
                                    } else if (indexString.slice(-1) === "1"){
                                        numberLabel = "nd"
                                    } else if (indexString.slice(-1) === "2"){
                                        numberLabel = "rd"
                                    }
                                }
                                
                                if (index > 2) {
                                    background = "background-black"
                                }
                                if(!element){
                                    return null
                                }
                                return (
                                    <li key={index}>
                                        <Link to={`/charactor-info/${element.charactorName}`}>
                                            <p className={`rank ${background}`}>{index+1}{numberLabel}</p>
                                            <img src={element.charactorImage} alt="" />
                                            <h4>{element.charactorName}</h4>
                                            <p className="combat-stat">{formatNumber(element.combatStat).slice(0, -5)}</p>
                                        </Link>
                                    </li>
                                )
                            }
                        )
                        :null
                    }

                </ul>
            </article>
        </RankCombatStatWrapper>
    )
}

export default RankCombatStat;